import { createFileRoute } from "@tanstack/react-router";
import WhatIsTmsTherapyArticlePage from "@/pages/articles/WhatIsTmsTherapyArticlePage";
export const Route = createFileRoute("/what-is-tms-therapy")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What Is TMS Therapy? Guide | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What is TMS therapy? Learn how transcranial magnetic stimulation works for depression, what a session feels like, and if it may help you in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "What Is TMS Therapy? Guide | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What is TMS therapy? Learn how transcranial magnetic stimulation works for depression, what a session feels like, and if it may help you in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/what-is-tms-therapy",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-tms-therapy",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsTmsTherapyArticlePage />;
}
